module.exports = __webpack_public_path__ + "0c4680ba7a6fea85542693140cb94448.jpg";